import { Component, OnInit } from '@angular/core';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatTabChangeEvent } from '@angular/material';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';

@Component({
  selector: 'app-checkedin',
  templateUrl: './checkedin.component.html',
  styleUrls: ['./checkedin.component.css'],

})

export class CheckedinComponent implements OnInit {
  public widgetposition: number = 0;
  public tabIndex: number;
  patId: string;
  appId: string;
   constructor(private schedulerService: SchedularServiceService, private router: Router,
    private route: ActivatedRoute, private crypto: AESAlgorithm,) {
    this.route.queryParams.subscribe(params => {
      this.patId = this.crypto.urlParmeterDecoder(decodeURIComponent(params['patId']));
      this.appId = this.crypto.urlParmeterDecoder(decodeURIComponent(params['appId']));
      CommonComponents.patientId = Number(this.patId);
    });
    
   
    sessionStorage.setItem("patientId", this.patId);
    sessionStorage.setItem("appId", sessionStorage.getItem("appId").toString());
    CommonComponents.demoheaderVisibility = false;
    sessionStorage.setItem("demoheaderVisibility","false");
   
 
    this.router.navigateByUrl('/CheckInalerts');


  }

  ngOnInit() {

  }
  
  onLinkClick(event: MatTabChangeEvent) {
     
    event.tab.isActive = true;
    var tabName = event.tab.textLabel;
    if (tabName == 'Contact Information')
      tabName = 'contact';
    if (tabName == 'Insurance Information')
      tabName = 'Insurance';
    if (tabName == 'Documents')
      tabName = 'documents';
    if (tabName == 'Payments')
      tabName = 'payments';
    if (tabName == 'Alerts')
      tabName = 'alerts';
    this.router.navigateByUrl('/CheckIn' + tabName.replace(" ", ""));
  }

  nextTabo() {
    if (this.widgetposition < 5) {
      this.widgetposition += 1;
    }
  }
  previusTabo() {
    if (this.widgetposition >= 0) {
      this.widgetposition -= 1;
    }
  }
  tabChanged(event){

  }
}
